import moment from 'moment';
import removeNotification from '../../../modules/notifications/actions/remove';

export function watch(dispatch, { notification }) {
    if (notification.expiresAt && moment().isBefore(notification.expiresAt)) {
        setTimeout(() => {
            dispatch(removeNotification(notification.id));
        }, -moment().diff(notification.expiresAt));
    }
}
